import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const sslMate = defineConnector({
  identifier: "sslMate",
  name: "SSLMate",
  tagLine: "Certificate lifecycle automation",
  logo,
  protocol: "http",
  tags: ["security"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your SSLMate API key",
      items: [
        {
          kind: "markdown",
          content:
            "In SSLMate, create an API key from your account settings and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your SSLMate details",
      items: [
        {
          kind: "url",
          label: "SSLMate base URL",
          required: true,
          placeholder: "https://sslmate.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://sslmate.com"}/api/v3/orders/example.com`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://(sandbox\\.)?sslmate\\.com/.*"),
});
